import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import { useLoaderData, useNavigate } from "react-router-dom";

import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";
import VisibilityIcon from "@mui/icons-material/Visibility";

import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

const CONTRACTOR_STATUS_LABELS = {
  1: "در انتظار بررسی",
  2: "تایید شده",
  3: "رد شده",
  4: "غیرفعال",
};

const ContractorInfoPage = () => {
  const pageInfo = useGetPageInfo();

  const dataList = useLoaderData("root");

  let navigate = useNavigate();
  const rows = (dataList || []).map((row) => ({
    ...row,
    contractorInfoStatusTitle:
      row.contractorInfoStatusTitle ||
      CONTRACTOR_STATUS_LABELS[row.contractorInfoStatus] ||
      "در انتظار بررسی",
  }));

  const headCells = [
    {
      id: "updateOn",
      label: "تاریخ",
      type: "date",
    },
    {
      id: "title",
      label: "نام شرکت",
    },
    {
      id: "contractorInfoStatusTitle",
      label: "وضعیت همکاری",
    },
    {
      id: "mobile",
      label: "همراه",
    },
    {
      id: "telephon",
      label: "تلفن",
    },
    {
      id: "city",
      label: "شهر",
    },
    {
      id: "address",
      label: "آدرس",
    },
  ];

  const onEditClicked = (row) => {
    navigate(`${row.id}`);
  };

  const onFetchData = () => {
    navigate();
  };

  const isReadOnlyRow = (row) =>
    Number(row.contractorInfoStatus) === 2 || row.contractorInfoStatusTitle === "تایید شده";

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />

                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12}>
                <EnhancedTable
                  rowKey={"id"}
                  rows={rows}
                  headCells={headCells}
                  pageSize={100}
                  actions={[
                    {
                      icon: <VisibilityIcon sx={{ width: "1rem", height: "1rem" }} />,
                      onClick: onEditClicked,
                      color: "primary",
                      tooltip: "مشاهده",
                      hidden: (row) => !isReadOnlyRow(row),
                    },
                    {
                      icon: <EditIcon sx={{ width: "1rem", height: "1rem" }} />,
                      onClick: onEditClicked,
                      color: "primary",
                      tooltip: "ویرایش",
                      hidden: (row) => isReadOnlyRow(row),
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ContractorInfoPage;
